import { defineComponent } from 'vue'

import useAppLoading from '@/composables/common/loading/useAppLoading'

import VLoading from './VLoading'

export default defineComponent(() => {
  const { isShowNormalLoading, isShowWaitLoading } = useAppLoading()
  return () => (
    <>
      {isShowNormalLoading.value &&
        <VLoading />}
      {isShowWaitLoading.value &&
        <VLoading />}
    </>
  )
},
{
  name: 'AppLoading'
})
